import React, { useState, useMemo } from "react";
import { MY_SPOTS, SPOT_STATUSES } from "../../data/mockData";
import { Building2, Factory, Briefcase, Hotel, Home as HomeIcon, Dumbbell, Truck } from "lucide-react";

const CAT_ICON = {
  warehouse: Building2, manufacturing: Factory, office: Briefcase,
  hotel: Hotel, apartment: HomeIcon, gym: Dumbbell, logistics: Truck,
};

const TABS = [
  { key: "all", label: "All" },
  { key: "submitted", label: "Submitted", statuses: ["submitted", "duplicate_check"] },
  { key: "verified", label: "Verified", statuses: ["verified", "awaiting_verification", "marketplace_ready"] },
  { key: "sold", label: "Sold", statuses: ["listed", "sold", "protection", "completed"] },
];

export default function MySpots() {
  const [tab, setTab] = useState("all");
  const filtered = useMemo(() => {
    if (tab === "all") return MY_SPOTS;
    const t = TABS.find((x) => x.key === tab);
    return MY_SPOTS.filter((s) => t.statuses.includes(s.status));
  }, [tab]);

  return (
    <div className="p-4 pb-6">
      <div className="flex items-center justify-between">
        <h1 className="text-[24px] font-black">My Spots</h1>
        <span className="sb-pill sb-pill-gray">{MY_SPOTS.length} total</span>
      </div>

      <div className="mt-4 sb-hscroll flex gap-2">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            data-testid={`spots-tab-${t.key}`}
            className={`px-4 py-2 rounded-full text-[12px] font-semibold whitespace-nowrap border transition-colors ${
              tab === t.key ? "bg-[#FFC107] text-[#080B0D] border-[#FFC107]" : "border-[#2A2F34] text-[#A1A1AA]"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="mt-4 space-y-3">
        {filtered.map((s) => {
          const Icon = CAT_ICON[s.category] || Building2;
          const st = SPOT_STATUSES.find((x) => x.key === s.status);
          return (
            <div key={s.id} data-testid={`spot-${s.id}`} className="sb-card p-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-[#FFC107]/10 flex items-center justify-center shrink-0">
                  <Icon size={18} className="text-[#FFC107]" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-[13px] font-bold truncate">{s.label}</div>
                  <div className="text-[11px] text-[#A1A1AA] mt-0.5">Submitted {s.date}</div>
                </div>
                <span className={`sb-pill ${st?.pill}`} style={{ fontSize: 9 }}>{st?.label}</span>
              </div>
              <div className="mt-3 flex items-center justify-between">
                <span className="text-[11px] text-[#A1A1AA]">
                  {s.awarded ? "Bounty" : "Potential"}: <span className={`font-black ${s.awarded ? "text-[#FFC107]" : "text-white"}`}>${s.potential}</span>
                </span>
                <button className="text-[11px] text-[#A1A1AA] hover:text-[#FFC107]">View →</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
